import React from "react";
import Typography, { ETypo, ETypoColor } from "@Front/Components/DesignSystem/Typography";
import { useDeploymentLineLegalPublisher } from "@Front/Services/DeploymentLineLegalPublisher/DeploymentLineLegalPublisherContext";

export function CGUSection12_1PartA(): React.JSX.Element {
	const pub = useDeploymentLineLegalPublisher();
	return (
		<>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				Le contenu du Site, la structure générale ainsi que les logiciels, textes, images animées ou non, photographies, son
				savoir-faire et tous les autres éléments composant le Site sont la propriété exclusive {pub.publisherFrenchExclusiveDeParticle} ou des tiers qui lui
				ont concédé une licence.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				L&apos;ensemble des éléments du le Site, sont protégés par le droit d&apos;auteur, le droit des marques, des dessins et modèles et/ou
				tous autres droits de propriété intellectuelle.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				Aucun titre ni droit quelconque sur aucun élément ou logiciel ne sera obtenu par téléchargement ou copie d&apos;éléments de ce
				Site. Il est formellement interdit à l&apos;Internaute de reproduire (à part pour son utilisation personnelle et non
				commerciale), publier, 7 éditer, transmettre, distribuer, montrer, enlever, supprimer, ajouter à ce Site et aux éléments et
				logiciels qu&apos;ils contiennent, pas plus que les modifier ou effectuer un quelconque travail en les prenant pour base, ni
				vendre ou participer à aucune vente en rapport avec ce Site, les éléments de ce Site ni aucun logiciel y afférant.
			</Typography>
		</>
	);
}

export function CGUSection12_1PartB(): React.JSX.Element {
	const pub = useDeploymentLineLegalPublisher();
	return (
		<>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				L&apos;Internaute s&apos;interdit notamment de modifier, copier, reproduire, télécharger, diffuser, transmettre, exploiter
				commercialement et/ou distribuer de quelque façon que ce soit les pages du Site, ou les codes informatiques des éléments
				composant le Site.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				Les présentes conditions générales d&apos;utilisation n&apos;emportent aucune cession d&apos;aucune sorte de droit de propriété
				intellectuelle sur les éléments appartenant à {pub.publisherLegalName} ou ayants droit tels que les sons, photographies, images, textes
				littéraires, travaux artistiques, logiciels, marques, chartes graphiques, logos au bénéfice du consommateur.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				{pub.publisherLegalName} concède à l&apos;Internaute une licence non exclusive pour utiliser le Site. Cette licence est strictement
				personnelle et ne peut en aucun cas être cédée ou transférée à quel que tiers que ce soit. La licence est concédée pour la
				durée d&apos;utilisation du Site.
			</Typography>
		</>
	);
}

export function CGUSection12_1PartC(): React.JSX.Element {
	const pub = useDeploymentLineLegalPublisher();
	return (
		<>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				Toute reproduction et/ou représentation, totale ou partielle d&apos;un de ces droits, sans l&apos;autorisation expresse de
				{pub.publisherLegalName}, est interdite et constituerait une contrefaçon susceptible d&apos;engager la responsabilité civile et pénale du
				contrefacteur.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				En conséquence, l&apos;Internaute s&apos;interdit tout agissement et tout acte susceptible de porter atteinte directement ou non aux
				droits de propriété intellectuelle de {pub.publisherLegalName}.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				Il en est de même des bases de données figurant, le cas échéant, sur le Site qui sont protégées par les articles du Code de
				la propriété intellectuelle. Toute extraction ou réutilisation, totale ou partielle desdites bases et de leur contenu est
				ainsi interdite sans l&apos;autorisation préalable expresse de {pub.publisherLegalName}.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				Seule une utilisation conforme à la destination de ce Site est autorisée.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				Toute autre utilisation, non expressément autorisée par écrit et au préalable par {pub.publisherLegalName}, est prohibée et constitutive
				de contrefaçon.
			</Typography>
		</>
	);
}
